export interface DeviceModel {
  id: string;
  name: string;
  goodPrice: number;    // working, good condition
  brokenPrice: number;  // not powering on or major damage
}

export interface DeviceCategory {
  id: string;
  name: string;
  emoji: string;
  description: string;
  needsAccountCheck: boolean;  // iCloud / Google account
  needsCarrierCheck: boolean;  // blacklist / carrier check (phones only)
  models: DeviceModel[];
}

export const BUYBACK_CATEGORIES: DeviceCategory[] = [
  {
    id: 'iphone',
    name: 'iPhone',
    emoji: '📱',
    description: 'All models, working or broken',
    needsAccountCheck: true,
    needsCarrierCheck: true,
    models: [
      { id: 'iphone-16-pro-max',   name: 'iPhone 16 Pro Max',   goodPrice: 750, brokenPrice: 200 },
      { id: 'iphone-16-pro',       name: 'iPhone 16 Pro',        goodPrice: 650, brokenPrice: 175 },
      { id: 'iphone-16-plus',      name: 'iPhone 16 Plus',       goodPrice: 480, brokenPrice: 130 },
      { id: 'iphone-16',           name: 'iPhone 16',            goodPrice: 420, brokenPrice: 110 },
      { id: 'iphone-15-pro-max',   name: 'iPhone 15 Pro Max',    goodPrice: 540, brokenPrice: 150 },
      { id: 'iphone-15-pro',       name: 'iPhone 15 Pro',        goodPrice: 440, brokenPrice: 120 },
      { id: 'iphone-15-plus',      name: 'iPhone 15 Plus',       goodPrice: 320, brokenPrice: 90  },
      { id: 'iphone-15',           name: 'iPhone 15',            goodPrice: 280, brokenPrice: 80  },
      { id: 'iphone-14-pro-max',   name: 'iPhone 14 Pro Max',    goodPrice: 370, brokenPrice: 100 },
      { id: 'iphone-14-pro',       name: 'iPhone 14 Pro',        goodPrice: 310, brokenPrice: 85  },
      { id: 'iphone-14-plus',      name: 'iPhone 14 Plus',       goodPrice: 230, brokenPrice: 65  },
      { id: 'iphone-14',           name: 'iPhone 14',            goodPrice: 200, brokenPrice: 55  },
      { id: 'iphone-13-pro-max',   name: 'iPhone 13 Pro Max',    goodPrice: 270, brokenPrice: 75  },
      { id: 'iphone-13-pro',       name: 'iPhone 13 Pro',        goodPrice: 220, brokenPrice: 60  },
      { id: 'iphone-13',           name: 'iPhone 13',            goodPrice: 170, brokenPrice: 45  },
      { id: 'iphone-13-mini',      name: 'iPhone 13 mini',       goodPrice: 130, brokenPrice: 35  },
      { id: 'iphone-12-pro-max',   name: 'iPhone 12 Pro Max',    goodPrice: 170, brokenPrice: 45  },
      { id: 'iphone-12-pro',       name: 'iPhone 12 Pro',        goodPrice: 140, brokenPrice: 38  },
      { id: 'iphone-12',           name: 'iPhone 12',            goodPrice: 110, brokenPrice: 30  },
      { id: 'iphone-12-mini',      name: 'iPhone 12 mini',       goodPrice: 85,  brokenPrice: 22  },
      { id: 'iphone-11-pro-max',   name: 'iPhone 11 Pro Max',    goodPrice: 110, brokenPrice: 30  },
      { id: 'iphone-11-pro',       name: 'iPhone 11 Pro',        goodPrice: 90,  brokenPrice: 25  },
      { id: 'iphone-11',           name: 'iPhone 11',            goodPrice: 75,  brokenPrice: 20  },
      { id: 'iphone-xr',           name: 'iPhone XR',            goodPrice: 60,  brokenPrice: 15  },
      { id: 'iphone-xs-max',       name: 'iPhone XS Max',        goodPrice: 65,  brokenPrice: 18  },
      { id: 'iphone-xs',           name: 'iPhone XS',            goodPrice: 55,  brokenPrice: 15  },
      { id: 'iphone-x',            name: 'iPhone X',             goodPrice: 45,  brokenPrice: 12  },
      { id: 'iphone-se-3',         name: 'iPhone SE (3rd gen)',   goodPrice: 85,  brokenPrice: 22  },
      { id: 'iphone-se-2',         name: 'iPhone SE (2nd gen)',   goodPrice: 45,  brokenPrice: 12  },
      { id: 'iphone-8-plus',       name: 'iPhone 8 Plus',        goodPrice: 35,  brokenPrice: 10  },
      { id: 'iphone-8',            name: 'iPhone 8',             goodPrice: 25,  brokenPrice: 8   },
    ],
  },
  {
    id: 'ipad',
    name: 'iPad',
    emoji: '⬛',
    description: 'All iPad models accepted',
    needsAccountCheck: true,
    needsCarrierCheck: false,
    models: [
      { id: 'ipad-pro-13-m4',      name: 'iPad Pro 13" (M4)',      goodPrice: 650, brokenPrice: 160 },
      { id: 'ipad-pro-11-m4',      name: 'iPad Pro 11" (M4)',      goodPrice: 530, brokenPrice: 130 },
      { id: 'ipad-pro-13-m2',      name: 'iPad Pro 12.9" (M2)',    goodPrice: 490, brokenPrice: 120 },
      { id: 'ipad-pro-11-m2',      name: 'iPad Pro 11" (M2)',      goodPrice: 380, brokenPrice: 95  },
      { id: 'ipad-air-13-m2',      name: 'iPad Air 13" (M2)',      goodPrice: 460, brokenPrice: 110 },
      { id: 'ipad-air-11-m2',      name: 'iPad Air 11" (M2)',      goodPrice: 360, brokenPrice: 90  },
      { id: 'ipad-air-5',          name: 'iPad Air (5th gen)',      goodPrice: 270, brokenPrice: 65  },
      { id: 'ipad-air-4',          name: 'iPad Air (4th gen)',      goodPrice: 190, brokenPrice: 48  },
      { id: 'ipad-mini-7',         name: 'iPad mini (7th gen)',     goodPrice: 310, brokenPrice: 75  },
      { id: 'ipad-mini-6',         name: 'iPad mini (6th gen)',     goodPrice: 240, brokenPrice: 60  },
      { id: 'ipad-mini-5',         name: 'iPad mini (5th gen)',     goodPrice: 120, brokenPrice: 30  },
      { id: 'ipad-10',             name: 'iPad (10th gen)',         goodPrice: 240, brokenPrice: 58  },
      { id: 'ipad-9',              name: 'iPad (9th gen)',          goodPrice: 120, brokenPrice: 30  },
      { id: 'ipad-8',              name: 'iPad (8th gen)',          goodPrice: 90,  brokenPrice: 22  },
    ],
  },
  {
    id: 'macbook',
    name: 'MacBook',
    emoji: '💻',
    description: 'MacBook Air & Pro, all chips',
    needsAccountCheck: true,
    needsCarrierCheck: false,
    models: [
      { id: 'mbp-16-m4-max',   name: 'MacBook Pro 16" M4 Max',   goodPrice: 1600, brokenPrice: 400 },
      { id: 'mbp-16-m4-pro',   name: 'MacBook Pro 16" M4 Pro',   goodPrice: 1250, brokenPrice: 320 },
      { id: 'mbp-16-m3-max',   name: 'MacBook Pro 16" M3 Max',   goodPrice: 1300, brokenPrice: 330 },
      { id: 'mbp-16-m3-pro',   name: 'MacBook Pro 16" M3 Pro',   goodPrice: 1000, brokenPrice: 260 },
      { id: 'mbp-14-m4-pro',   name: 'MacBook Pro 14" M4 Pro',   goodPrice: 1050, brokenPrice: 270 },
      { id: 'mbp-14-m3-pro',   name: 'MacBook Pro 14" M3 Pro',   goodPrice: 850,  brokenPrice: 220 },
      { id: 'mbp-14-m3',       name: 'MacBook Pro 14" M3',       goodPrice: 700,  brokenPrice: 180 },
      { id: 'mbp-13-m2',       name: 'MacBook Pro 13" M2',       goodPrice: 550,  brokenPrice: 140 },
      { id: 'mbp-13-m1',       name: 'MacBook Pro 13" M1',       goodPrice: 480,  brokenPrice: 120 },
      { id: 'mba-15-m3',       name: 'MacBook Air 15" M3',       goodPrice: 800,  brokenPrice: 200 },
      { id: 'mba-15-m2',       name: 'MacBook Air 15" M2',       goodPrice: 680,  brokenPrice: 170 },
      { id: 'mba-13-m3',       name: 'MacBook Air 13" M3',       goodPrice: 650,  brokenPrice: 165 },
      { id: 'mba-13-m2',       name: 'MacBook Air 13" M2',       goodPrice: 530,  brokenPrice: 135 },
      { id: 'mba-13-m1',       name: 'MacBook Air 13" M1',       goodPrice: 380,  brokenPrice: 95  },
      { id: 'mbp-16-intel',    name: 'MacBook Pro 16" (Intel)',   goodPrice: 380,  brokenPrice: 95  },
      { id: 'mbp-13-intel',    name: 'MacBook Pro 13" (Intel)',   goodPrice: 240,  brokenPrice: 60  },
      { id: 'mba-intel',       name: 'MacBook Air (Intel)',       goodPrice: 140,  brokenPrice: 35  },
    ],
  },
  {
    id: 'ps5',
    name: 'PS5',
    emoji: '🎮',
    description: 'All PS5 models, working or broken',
    needsAccountCheck: false,
    needsCarrierCheck: false,
    models: [
      { id: 'ps5-pro',          name: 'PS5 Pro',               goodPrice: 380, brokenPrice: 120 },
      { id: 'ps5-slim-disc',    name: 'PS5 Slim (Disc)',        goodPrice: 290, brokenPrice: 90  },
      { id: 'ps5-slim-digital', name: 'PS5 Slim (Digital)',     goodPrice: 240, brokenPrice: 75  },
      { id: 'ps5-disc',         name: 'PS5 (Original Disc)',    goodPrice: 260, brokenPrice: 80  },
      { id: 'ps5-digital',      name: 'PS5 (Original Digital)', goodPrice: 210, brokenPrice: 65  },
    ],
  },
  {
    id: 'xbox',
    name: 'Xbox',
    emoji: '🟢',
    description: 'Series X/S and older models',
    needsAccountCheck: false,
    needsCarrierCheck: false,
    models: [
      { id: 'xbox-series-x',   name: 'Xbox Series X',   goodPrice: 230, brokenPrice: 70  },
      { id: 'xbox-series-s',   name: 'Xbox Series S',   goodPrice: 140, brokenPrice: 42  },
      { id: 'xbox-one-x',      name: 'Xbox One X',      goodPrice: 85,  brokenPrice: 25  },
      { id: 'xbox-one-s',      name: 'Xbox One S',      goodPrice: 60,  brokenPrice: 18  },
      { id: 'xbox-one',        name: 'Xbox One',        goodPrice: 40,  brokenPrice: 12  },
    ],
  },
  {
    id: 'switch',
    name: 'Nintendo Switch',
    emoji: '🕹️',
    description: 'All Switch models & Switch 2',
    needsAccountCheck: false,
    needsCarrierCheck: false,
    models: [
      { id: 'switch-2',         name: 'Nintendo Switch 2',       goodPrice: 380, brokenPrice: 120 },
      { id: 'switch-oled',      name: 'Switch OLED',             goodPrice: 190, brokenPrice: 60  },
      { id: 'switch-v2',        name: 'Switch V2 (patched)',      goodPrice: 140, brokenPrice: 45  },
      { id: 'switch-v1',        name: 'Switch V1 (unpatched)',    goodPrice: 175, brokenPrice: 55  },
      { id: 'switch-lite',      name: 'Switch Lite',             goodPrice: 95,  brokenPrice: 30  },
    ],
  },
  {
    id: 'handheld-pc',
    name: 'Handheld PC',
    emoji: '🖥️',
    description: 'Steam Deck, ROG Ally & more',
    needsAccountCheck: false,
    needsCarrierCheck: false,
    models: [
      { id: 'steam-deck-oled',      name: 'Steam Deck OLED (1TB)',   goodPrice: 380, brokenPrice: 110 },
      { id: 'steam-deck-oled-512',  name: 'Steam Deck OLED (512GB)', goodPrice: 330, brokenPrice: 95  },
      { id: 'steam-deck-512',       name: 'Steam Deck LCD (512GB)',  goodPrice: 230, brokenPrice: 65  },
      { id: 'steam-deck-256',       name: 'Steam Deck LCD (256GB)',  goodPrice: 190, brokenPrice: 55  },
      { id: 'steam-deck-64',        name: 'Steam Deck LCD (64GB)',   goodPrice: 150, brokenPrice: 42  },
      { id: 'rog-ally-x',           name: 'ROG Ally X',              goodPrice: 420, brokenPrice: 120 },
      { id: 'rog-ally',             name: 'ROG Ally (Z1 Extreme)',   goodPrice: 280, brokenPrice: 80  },
    ],
  },
  {
    id: 'retro',
    name: 'Retro / Game Boy',
    emoji: '👾',
    description: 'Game Boy, DS, 3DS & classics',
    needsAccountCheck: false,
    needsCarrierCheck: false,
    models: [
      { id: 'new-3ds-xl',      name: 'New 3DS XL',           goodPrice: 90,  brokenPrice: 28  },
      { id: 'new-3ds',         name: 'New 3DS',              goodPrice: 75,  brokenPrice: 22  },
      { id: '3ds-xl',          name: '3DS XL',               goodPrice: 65,  brokenPrice: 18  },
      { id: '3ds',             name: '3DS',                  goodPrice: 50,  brokenPrice: 15  },
      { id: '2ds-xl',          name: 'New 2DS XL',           goodPrice: 70,  brokenPrice: 20  },
      { id: '2ds',             name: '2DS',                  goodPrice: 35,  brokenPrice: 10  },
      { id: 'ds-lite',         name: 'DS Lite',              goodPrice: 35,  brokenPrice: 10  },
      { id: 'dsi',             name: 'DSi / DSi XL',         goodPrice: 28,  brokenPrice: 8   },
      { id: 'gba-sp-101',      name: 'GBA SP (AGS-101 backlit)', goodPrice: 90, brokenPrice: 25 },
      { id: 'gba-sp-001',      name: 'GBA SP (AGS-001)',     goodPrice: 55,  brokenPrice: 15  },
      { id: 'gba',             name: 'Game Boy Advance',     goodPrice: 40,  brokenPrice: 12  },
      { id: 'gbc',             name: 'Game Boy Color',       goodPrice: 45,  brokenPrice: 14  },
      { id: 'gbp',             name: 'Game Boy Pocket',      goodPrice: 45,  brokenPrice: 14  },
      { id: 'dmg',             name: 'Game Boy (Original DMG)', goodPrice: 50, brokenPrice: 15 },
    ],
  },
];

export const getCategory = (id: string) =>
  BUYBACK_CATEGORIES.find(c => c.id === id);

export const getModel = (categoryId: string, modelId: string) =>
  getCategory(categoryId)?.models.find(m => m.id === modelId);

export type Condition = 'like-new' | 'good' | 'fair' | 'broken';

export const CONDITIONS = [
  {
    id: 'like-new' as Condition,
    label: 'Like New',
    desc: 'Minimal use, no scratches or marks. Fully functional. All original accessories included.',
    multiplier: 1.15,
    color: '#39FF14',
  },
  {
    id: 'good' as Condition,
    label: 'Good',
    desc: 'Light signs of use, fully functional. Minor scuffs okay. May be missing accessories.',
    multiplier: 1.0,
    color: '#00BFFF',
  },
  {
    id: 'fair' as Condition,
    label: 'Fair',
    desc: 'Noticeable wear, scratches, or minor cosmetic damage. Still powers on and works.',
    multiplier: 0.6,
    color: '#FFA500',
  },
  {
    id: 'broken' as Condition,
    label: 'Broken',
    desc: "Won't power on, cracked screen, major damage, or significant missing parts.",
    multiplier: 0,
    color: '#FF1744',
  },
] as const;

export function calculateOffer(
  categoryId: string,
  modelId: string,
  condition: Condition,
  iCloudUnlocked?: boolean,
  blacklistClean?: boolean,
): number {
  const model = getModel(categoryId, modelId);
  if (!model) return 0;

  let price =
    condition === 'broken'
      ? model.brokenPrice
      : Math.round(model.goodPrice * CONDITIONS.find(c => c.id === condition)!.multiplier);

  // Apple account/carrier penalties bring it to parts-only value
  if (iCloudUnlocked === false) price = Math.round(model.brokenPrice * 0.4);
  if (blacklistClean === false) price = Math.round(model.brokenPrice * 0.25);

  return Math.max(5, Math.round(price / 5) * 5);
}
